import { fetchApi } from './utils';

import * as QuestionTypes from '@coconut/constants/questionType';

export const getTutorQuestionsHistory = ({
  uid,
  statuses,
  abbr = undefined,
  page = 1,
  type = QuestionTypes.ALL_QUESTION,
}) =>
  fetchApi(`api/v2/tutors/${uid}/questions_history`, 'GET', {
    params: {
      statuses,
      subject_abbr: abbr,
      size_per_page: 25,
      page,
      type,
    },
  });

export const patchPickQuestion = ({ uid, questionId }) =>
  fetchApi(`api/v2/tutors/${uid}/questions/${questionId}/pick`, 'PATCH');

export const patchDeclineQuestion = ({ uid, questionId }) =>
  fetchApi(
    `api/v2/tutors/${uid}/questions/${questionId}/tutor_reject`,
    'PATCH'
  );



// WEBPACK FOOTER //
// ./src/services/apis/tutor.js